import React from "react";

export const TabsData = [
  {
    id: 1,
    icon: "sort-alphabetical",
    title: "Tab 1",
    panel: <div />,
    visible: true
  },
  {
    id: 2,
    icon: "sort-alphabetical-desc",
    title: "Tab 2",
    panel: <div />,
    visible: true
  },
  {
    id: 3,
    icon: "sort-asc",
    title: "Tab 3",
    panel: <div />,
    visible: true
  },
  {
    id: 4,
    icon: "sort-desc",
    title: "Tab 4",
    panel: <div />,
    visible: true
  }
];
